(() => {
  const story = document.getElementById('hdjf9-story');
  if (story) {
    const stickyCart = document.querySelector('.kt-sticky-add-to-cart');
    const updateVisibility = () => {
      const bounds = story.getBoundingClientRect();
      story.style.setProperty('--hdjf9-cart-clearance', stickyCart ? `${stickyCart.getBoundingClientRect().height + 40}px` : '0px');
      story.classList.toggle('hdjf9-story-inview', bounds.top < window.innerHeight * 0.5 && bounds.bottom > window.innerHeight * 0.5);
    };
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    if (stickyCart) new ResizeObserver(updateVisibility).observe(stickyCart);
    updateVisibility();
  }
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('#App')) window.location.reload();
    });
  }
})();
